<div mat-dialog-content>{{message}}</div>
<div class="dialog-footer-2">
	<div class="generic-buttons-blue">
		<button mat-button (click)="onNoClick()">Cancelar</button>
	</div>
	<div class="generic-buttons-blue-revert">
		<button mat-button [mat-dialog-close]="true" cdkFocusInitial>Confirmar</button>
	</div>
</div>
